var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/HangingSign.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var HangingSign = function HangingSign(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, "Hanging sign"), /*#__PURE__*/React.createElement("path", {
    d: "M40.9706 7.85063H10.7831V3.4375C10.7831 2.64359 10.1395 2 9.34563 2C8.55172 2 7.90813 2.64359 7.90813 3.4375V7.85063H3.4375C2.64359 7.85063 2 8.49422 2 9.28813C2 10.082 2.64359 10.7256 3.4375 10.7256H7.90813V40.9994C7.95381 41.7594 8.58421 42.352 9.34563 42.3506C10.1018 42.3525 10.7302 41.7681 10.7831 41.0137V10.7256H16.5331V13.6006H19.4081V10.7256H33.7831V13.6006H36.6581V10.7256H40.9706C41.7645 10.7256 42.4081 10.082 42.4081 9.28813C42.4081 8.49422 41.7645 7.85063 40.9706 7.85063Z",
    fill: "#006AFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "13.6582",
    y: "13.6006",
    width: "25.875",
    height: "18.6875",
    rx: "2",
    fill: "#006AFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }));
};

HangingSign.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HangingSign.defaultProps = {
  className: null
};
export default HangingSign;